import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EndorsementComponent } from './components/endorsement/endorsement.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MaterialModule } from '../material/material.module';
import { DyanamicFieldsFormModule } from '../dyanamic-fields-form/dyanamic-fields-form.module';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PoliciesDropdownComponent } from './components/policies-dropdown/policies-dropdown.component';
import { ApproveRejectComponent } from './components/approve-reject/approve-reject.component';
import { CpSideBarComponent } from './components/cp-side-bar/cp-side-bar.component';
import { CpHeaderComponent } from './components/cp-header/cp-header.component';
import { RouterModule } from '@angular/router';
import { TrackClaimsComponent } from './components/track-claims/track-claims.component';
import { IntimateClaimComponent } from './components/intimate-claim/intimate-claim.component';
import { PolicyCoverageComponent } from './components/policy-coverage/policy-coverage.component';
import { ECardsComponent } from './components/e-cards/e-cards.component';
import { DownloadFormsComponent } from './components/download-forms/download-forms.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { FaqComponent } from './components/faq/faq.component';
import { ReportComponent } from './components/report/report.component';
import { HealthClaimMisComponent } from './components/report/health-claim-mis/health-claim-mis.component';
import { HealthEnrollmentMisComponent } from './components/report/health-enrollment-mis/health-enrollment-mis.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { CreateNotificationsComponent } from './components/notifications/create-notifications/create-notifications.component';
import { UserIdMisComponent } from './components/report/user-id-mis/user-id-mis.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { StaticDashboardComponent } from './components/dashboard/static-dashboard/static-dashboard.component';
import { DynamicDashboardComponent } from './components/dashboard/dynamic-dashboard/dynamic-dashboard.component';
import { EditNotificationComponent } from './components/notifications/edit-notification/edit-notification.component';
import { CorporatePortalBaseComponent } from './components/corporate-portal-base/corporate-portal-base.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FinalDeclarationComponent } from './components/final-declaration/final-declaration.component';
import { ActiveSessionsComponent } from './components/active-sessions/active-sessions.component';
import { GpaComponent } from './components/gpa/gpa.component';
import { ViewUploadedDocumentsComponent } from './components/track-claims/view-uploaded-documents/view-uploaded-documents.component';
import { PaciComponent } from './components/paci/paci.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ConfirmDialogPopupComponent } from './components/intimate-claim/confirm-dialog-popup/confirm-dialog-popup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepperModule } from '@angular/material/stepper';
import { ClaimIdCardComponent } from './components/track-claims/claim-details/claim-id-card/claim-id-card.component';
import { MediumCtaComponent } from './components/track-claims/claim-details/claim-id-card/medium-cta/medium-cta.component';
import { ClaimDetailsComponent } from './components/track-claims/claim-details/claim-details.component';
import { PhoneComponent } from './components/track-claims/claim-details/claim-journey-details/phone/phone.component';
import { PlusAnimationMobileComponent } from './components/track-claims/claim-details/claim-journey-details/plus-animation-mobile/plus-animation-mobile.component';
import { Property1CallStateDefaultComponent } from './components/track-claims/claim-details/claim-journey-details/property-1-call-state-default/property-1-call-state-default.component';
import { TrackClaimDetailsMobileComponent } from './components/track-claims/claim-details/claim-journey-details/track-claim-details-mobile.component';
import { PdfBlockComponent } from './components/track-claims/claim-details/pdf-block/pdf-block.component';
import { ActionBlockComponent } from './components/track-claims/claim-details/action-block/action-block.component';
import { ChipsMobileComponent } from './components/upload-documents/chips-mobile/chips-mobile.component';
import { CornerUpRightComponent } from './components/upload-documents/corner-up-right/corner-up-right.component';
import { DocumentUploadComponent } from './components/upload-documents/document-upload/document-upload.component';
import { ExtraLargeCtaComponent } from './components/upload-documents/extra-large-cta/extra-large-cta.component';
import { InputFieldBrightBgDesktopComponent } from './components/upload-documents/input-field-bright-bg-desktop/input-field-bright-bg-desktop.component';
import { Property1DirectionsStateDefaultComponent } from './components/upload-documents/property-1-directions-state-default/property-1-directions-state-default.component';
import { TertiaryCtaComponent } from './components/upload-documents/tertiary-cta/tertiary-cta.component';
import { TertiaryCtaBrightBgDesktopComponent } from './components/upload-documents/tertiary-cta-bright-bg-desktop/tertiary-cta-bright-bg-desktop.component';
import { TertiaryCtaBrightBgMobileComponent } from './components/upload-documents/tertiary-cta-bright-bg-mobile/tertiary-cta-bright-bg-mobile.component';
import { UploadedStatesCardMobileComponent } from './components/upload-documents/uploaded-states-card-mobile/uploaded-states-card-mobile.component';
import { ManageProfileComponent } from './components/manage-profile/manage-profile.component';
import { StartClaimComponent } from './components/start-claim/start-claim.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { OverlayModule } from '@angular/cdk/overlay';
import { NetworkHospitalsComponent } from './components/network-hospitals/network-hospitals.component';

@NgModule({
  declarations: [
    EndorsementComponent,
    PoliciesDropdownComponent,
    ApproveRejectComponent,
    CpHeaderComponent,
    CpSideBarComponent,
    TrackClaimsComponent,
    IntimateClaimComponent,
    PolicyCoverageComponent,
    NetworkHospitalsComponent,
    ECardsComponent,
    DownloadFormsComponent,
    ContactUsComponent,
    FaqComponent,
    ReportComponent,
    HealthClaimMisComponent,
    HealthEnrollmentMisComponent,
    NotificationsComponent,
    CreateNotificationsComponent,
    UserIdMisComponent,
    DashboardComponent,
    StaticDashboardComponent,
    EditNotificationComponent,
    DynamicDashboardComponent,
    FinalDeclarationComponent,
    ActiveSessionsComponent,
    GpaComponent,
    ViewUploadedDocumentsComponent,
    PaciComponent,
    ConfirmDialogPopupComponent,
    ClaimIdCardComponent,
    MediumCtaComponent,
    ClaimDetailsComponent,
    PhoneComponent,
    PlusAnimationMobileComponent,
    Property1CallStateDefaultComponent,
    TrackClaimDetailsMobileComponent,
    PdfBlockComponent,
    ActionBlockComponent,
    ChipsMobileComponent,
    CornerUpRightComponent,
    DocumentUploadComponent,
    ExtraLargeCtaComponent,
    InputFieldBrightBgDesktopComponent,
    PhoneComponent,
    Property1CallStateDefaultComponent,
    Property1DirectionsStateDefaultComponent,
    TertiaryCtaComponent,
    TertiaryCtaBrightBgDesktopComponent,
    TertiaryCtaBrightBgMobileComponent,
    UploadedStatesCardMobileComponent,
    ManageProfileComponent,
    StartClaimComponent,
  ],
  imports: [
    NgbModule,
    RouterModule,
    SharedModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    MaterialModule,
    DyanamicFieldsFormModule,
    SlickCarouselModule,
    MatTabsModule,
    MatStepperModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    MatProgressBarModule,
    OverlayModule
  ],
  exports: [
    EndorsementComponent,
    PoliciesDropdownComponent,
    ApproveRejectComponent,
    CpHeaderComponent,
    CpSideBarComponent,
    TrackClaimsComponent,
    IntimateClaimComponent,
    StartClaimComponent,
    PolicyCoverageComponent,
    NetworkHospitalsComponent,
    ECardsComponent,
    DownloadFormsComponent,
    ContactUsComponent,
    FaqComponent,
    ReportComponent,
    HealthClaimMisComponent,
    HealthEnrollmentMisComponent,
    NotificationsComponent,
    CreateNotificationsComponent,
    UserIdMisComponent,
    DashboardComponent,
    StaticDashboardComponent,
    DynamicDashboardComponent,
    EditNotificationComponent,
    ClaimIdCardComponent,
    MediumCtaComponent,
    ClaimDetailsComponent,
    PhoneComponent,
    PlusAnimationMobileComponent,
    Property1CallStateDefaultComponent,
    TrackClaimDetailsMobileComponent,
    PdfBlockComponent,
    ActionBlockComponent,
    ChipsMobileComponent,
    CornerUpRightComponent,
    DocumentUploadComponent,
    ExtraLargeCtaComponent,
    InputFieldBrightBgDesktopComponent,
    PhoneComponent,
    Property1CallStateDefaultComponent,
    Property1DirectionsStateDefaultComponent,
    TertiaryCtaComponent,
    TertiaryCtaBrightBgDesktopComponent,
    TertiaryCtaBrightBgMobileComponent,
    UploadedStatesCardMobileComponent,
    ManageProfileComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CorporatePortalModule {}
